import React, { useState } from "react"
import HeaderMobile from "./header-mobile"
import Svg from "../_svgs/svg"
import { CookiesProvider } from "react-cookie"
import LoginState from "../../booking/components/loginState"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import SearchSection from "./search-section"
import SearchSectionModal from "./search-section-modal"
import * as cookieHelper from "../../helpers/cookie"
import { isMobile } from "react-device-detect"
import UniverseSelectionBar from "./universe-selection-bar"
import LanguageSelector from "./language-selector"
import useWindowWidth from "../../hooks/useWindowWidth"

export default function Header({
  logo,
  logoOverride,
  logoLink,
  logoTracking,
  headerLinks,
  shopLogo,
  shopLogoLink,
  shopLogoTracking,
  languageChoiceLabel,
  languages,
  useParkingLanguageSelection,
  loginState,
  megaMenuCard,
  locale,
  searchConfig,
  accessibilityHeaderItems,
  universeSelection,
  universesSelectText,
  sectionNotAvailableText,
  pageNotAvailableText,
  onlyTopLevel = false,
  timeoutHandle = null,
  shopLogoLinkTarget,
  showLogin,
}) {
  const [isSearchActive, setIsSearchActive] = useState(false)
  const [isMobileSearchActive, setIsMobileSearchActive] = useState(false)
  const [isMobileMenuActive, setIsMobileMenuActive] = useState(false)
  const [activeLevel2Index, setActiveLevel2Index] = useState(null)
  const [topLevelHover, setTopLevelHover] = useState(false)
  const [subLevelHover, setSubLevelHover] = useState(false)
  const [mouseOverSearchToggle, setMouseOverSearchToggle] = useState(false)
  const windowWidth = useWindowWidth()

  const handleSearchToggle = () => {
    const notificationBanner = document.querySelector(".notifications")

    setTopLevelHover(false)
    setActiveLevel2Index(null)
    setSubLevelHover(false)

    if (isSearchActive) {
      if (notificationBanner) {
        const notificationVersion = notificationBanner.dataset.notificationVersion
        const notificationCookie = cookieHelper.getCookie(notificationVersion)
        if (notificationCookie !== "closed") {
          notificationBanner.style.display = "block"
        }
      }
    } else {
      if (notificationBanner) {
        notificationBanner.style.display = "none"
      }
      let siteHeader = document.getElementsByClassName("site-header")[0]
      if (siteHeader) {
        let siteHeaderWrapper = document.getElementsByClassName("site-header-wrapper")[0]
        if (siteHeaderWrapper) {
          siteHeaderWrapper.style.height = siteHeader.clientHeight + "px"
        }
      }
    }
    setIsSearchActive(!isSearchActive)
  }

  const handleMobileSearchOpen = () => {
    setZIndexOfNotificationBanner(0)
    setIsMobileSearchActive(true)
    document.body.classList.add("disable-scroll")
  }

  const handleMobileSearchClose = () => {
    setIsMobileSearchActive(false)
    setZIndexOfNotificationBanner(null)
    document.body.classList.remove("disable-scroll")
  }

  const handleSearchClose = () => {
    if (!mouseOverSearchToggle) {
      const notificationBanner = document.querySelector(".notifications")
      if (notificationBanner) {
        const notificationVersion = notificationBanner.dataset.notificationVersion
        const notificationCookie = cookieHelper.getCookie(notificationVersion)
        if (notificationCookie !== "closed") {
          notificationBanner.style.display = "block"
        }
      }
      setIsSearchActive(false)
    }
  }
  if (isMobile) {
    document.activeElement.blur()
  }

  const handleMobileMenuToggle = () => {
    if (!isMobileMenuActive) {
      setZIndexOfNotificationBanner(0)
      setIsMobileMenuActive(!isMobileMenuActive)
      document.body.classList.add("disable-scroll")
    } else {
      setIsMobileMenuActive(!isMobileMenuActive)
      setZIndexOfNotificationBanner(null)
      document.body.classList.remove("disable-scroll")
    }
  }

  const topLevelHoverHandler = (index, content) => {
    if (onlyTopLevel || isSearchActive) return

    clearTimeout(timeoutHandle)

    timeoutHandle = setTimeout(() => {
      if (content) {
        setActiveLevel2Index(index)
        setTopLevelHover(true)
      } else {
        setTopLevelHover(false)
        setActiveLevel2Index(null)
      }
    }, 200)
  }

  const topLevelUnhoverHandler = () => {
    if (onlyTopLevel || isSearchActive) return
    clearTimeout(timeoutHandle)

    timeoutHandle = setTimeout(() => {
      setTopLevelHover(false)
      if (!subLevelHover) {
        setActiveLevel2Index(null)
      }
    }, 100)
  }

  const subLevelHoverHandler = () => {
    if (onlyTopLevel || isSearchActive) return

    clearTimeout(timeoutHandle)
    setSubLevelHover(true)
    setTopLevelHover(false)
  }

  const subLevelUnhoverHandler = () => {
    if (onlyTopLevel || isSearchActive) return
    setSubLevelHover(false)
    if (!topLevelHover) setActiveLevel2Index(null)
    clearTimeout(timeoutHandle)
  }

  const handleClickTracking = (tracking) => {
    if (tracking) {
      try {
        tracking()
      } catch (error) {
        console.error("Error in tracking function", error)
      }
    }
  }

  const setZIndexOfNotificationBanner = (zindex) => {
    const notificationBanner = document.querySelector(".notification")
    if (notificationBanner) {
      const notificationVersion = notificationBanner.dataset.notificationVersion
      const notificationCookie = cookieHelper.getCookie(notificationVersion)
      if (notificationCookie !== "closed") {
        notificationBanner.style.zIndex = zindex
      }
    }
  }

  var renderedAccessibleHeaderItems = (
    <AccessibilityHeaderItems
      accessibleHeaderItems={accessibilityHeaderItems}
      setIsSearchActive={setIsSearchActive}
      setTopLevelHover={setTopLevelHover}
      setSubLevelHover={setSubLevelHover}
      setActiveLevel2Index={setActiveLevel2Index}
    />
  )

  const target = SelectionFactoryHelper.getFromSelectionFactory(shopLogoLinkTarget)

  return (
    <div className={`site-header js--site-header ${isSearchActive ? "is-sticky" : ""}`}>
      {windowWidth >= 950 ? (
        <UniverseSelectionBar universeSelection={universeSelection} universesSelectText={universesSelectText || "CPH Websites"} />
      ) : null}
      <nav className={`main-navigation`}>
        {renderedAccessibleHeaderItems}

        {/* Mobile */}
        {windowWidth < 950 ? (
          <HeaderMobile
            isMobileMenuActive={isMobileMenuActive}
            logo={logo}
            logoOverride={logoOverride}
            logoLink={logoLink}
            logoTracking={logoTracking}
            handleMobileSearchOpen={handleMobileSearchOpen}
            handleMobileMenuToggle={handleMobileMenuToggle}
            languages={languages}
            useParkingLanguageSelection={useParkingLanguageSelection}
            loginState={loginState}
            headerLinks={headerLinks}
            handleClickTracking={handleClickTracking}
            shopLogoTracking={shopLogoTracking}
            shopLogoLink={shopLogoLink}
            shopLogo={shopLogo}
            megaMenuCard={megaMenuCard}
            shopLogoLinkTarget={target}
            languageChoiceLabel={languageChoiceLabel}
            sectionNotAvailableText={sectionNotAvailableText}
            pageNotAvailableText={pageNotAvailableText}
            universeSelection={universeSelection}
            universesSelectText={universesSelectText || "CPH Websites"}
          />
        ) : undefined}

        {/* Desktop */}
        {windowWidth >= 950 ? (
          <div className={`main-navigation--desktop ${activeLevel2Index ? "is-active" : ""}`}>
            <div className="w--wider pos-static">
              <ul className="main-navigation--desktop__main">
                <li className="main-navigation__item">
                  <a
                    className={`button button--nav button--logo ${logoOverride && "button--logo--override"}`}
                    href={logoLink}
                    onClick={() => handleClickTracking(logoTracking)}
                  >
                    {logoOverride ? <img src={logoOverride} alt="Logo" /> : <Svg iconName={logo || "logo-tight"} />}
                  </a>
                </li>

                {headerLinks && headerLinks.length > 0
                  ? headerLinks.map((item, index) => {
                      return (
                        <HeaderElementTopLevel
                          key={`topLevelItem${index}`}
                          // {...item}
                          //The megaMenuCard is equivelent to
                          megaMenuCard={item.megaMenuCard}
                          setIsSearchActive={setIsSearchActive}
                          setTopLevelHover={setTopLevelHover}
                          setSubLevelHover={setSubLevelHover}
                          setActiveLevel2Index={setActiveLevel2Index}
                          icon={item.icon}
                          iconUpload={item.iconUpload}
                          selectedTags={item.selectedTags}
                          link={item.link}
                          linkText={item.linkText}
                          index={index}
                          handleClickTracking={handleClickTracking}
                          active={activeLevel2Index === index}
                          onlyTopLevel={onlyTopLevel}
                          mouseEnterHandler={topLevelHoverHandler}
                          mouseLeaveHandler={topLevelUnhoverHandler}
                          topLevelHover={topLevelHover}
                          windowWidth={windowWidth}
                          activeLevel2Index={activeLevel2Index}
                          headerLinks={headerLinks}
                          locale={locale}
                          subLevelHoverHandler={subLevelHoverHandler}
                          subLevelUnhoverHandler={subLevelUnhoverHandler}
                          sublevelHover={subLevelHover}
                          sectionNotAvailableText={sectionNotAvailableText}
                          pageNotAvailableText={pageNotAvailableText}
                        />
                      )
                    })
                  : ""}
              </ul>
              <ul className="main-navigation--desktop__aux">
                {shopLogo && shopLogoLink ? (
                  <li className="taxfreelink">
                    <a href={shopLogoLink} onClick={() => handleClickTracking(shopLogoTracking)} target={target}>
                      <img src={shopLogo} alt="" />
                    </a>
                  </li>
                ) : (
                  ""
                )}
                {showLogin ? (
                  <li className={`main-navigation__item main-navigation__item--bottom main-navigation__item--user`}>
                    <CookiesProvider>
                      <LoginState config={loginState} />
                    </CookiesProvider>
                  </li>
                ) : (
                  ""
                )}

                <LanguageSelector
                  languageChoiceLabel={languageChoiceLabel}
                  languages={languages}
                  useParkingLanguageSelection={useParkingLanguageSelection}
                />

                {/* Search Function */}
                <li
                  className="main-navigation__item search search--desktop"
                  onMouseOver={() => setMouseOverSearchToggle(true)}
                  onMouseOut={() => setMouseOverSearchToggle(false)}
                >
                  <button id="search" className="button button--nav for-search js--search-field-toggle" onClick={() => handleSearchToggle()}>
                    <Svg iconClass={"icon"} iconName={"search-new"} />
                  </button>
                </li>
              </ul>
            </div>
          </div>
        ) : undefined}
      </nav>
      {windowWidth < 950 ? (
        <SearchSectionModal searchConfig={searchConfig} searchOpen={isMobileSearchActive} closeHandler={handleMobileSearchClose} />
      ) : (
        <SearchSection
          searchConfig={searchConfig}
          isSearchActive={isSearchActive}
          handleOutsideClick={handleSearchClose}
          closeHandler={handleSearchClose}
        ></SearchSection>
      )}
    </div>
  )
}

function HeaderElementTopLevel({
  //default props in functional components
  index = 0,
  onlyTopLevel = false,
  mouseEnterHandler = null,
  mouseLeaveHandler = null,
  link,
  linkText,
  linkTracking,
  active,
  handleClickTracking,
  megaMenuCard,
  windowWidth,
  activeLevel2Index,
  headerLinks,
  locale,
  subLevelHoverHandler,
  subLevelUnhoverHandler,
  subLevelHover,
  topLevelHover,
  setIsSearchActive,
  setTopLevelHover,
  setActiveLevel2Index,
  sectionNotAvailableText,
  pageNotAvailableText,
}) {
  const headerLinkToRender = headerLinks && headerLinks[index]

  const handleEnterKeyPress = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault()
      if (!active) {
        setIsSearchActive(false)
        setTopLevelHover(true)
        setActiveLevel2Index(index)
        mouseEnterHandler(index, megaMenuCard)
        return
      }

      mouseLeaveHandler()
      return
    }
  }

  if (link && linkText) {
    return (
      <li
        onMouseLeave={() => mouseLeaveHandler()}
        onClick={() => handleClickTracking(linkTracking)}
        className={`main-navigation__item ${active ? "is-highlighted" : ""}`}
      >
        <a
          onMouseEnter={() => mouseEnterHandler(index, megaMenuCard)}
          onKeyDown={(e) => handleEnterKeyPress(e)}
          className={`button button--nav ${active ? "is-active" : ""}`}
          href={link}
        >
          <span className="text">{linkText}</span>
        </a>
        {!onlyTopLevel && windowWidth >= 950 && (
          <div className={`main-navigation--desktop__main__level2 ${activeLevel2Index === index && active ? "is-active" : ""}`}>
            {headerLinkToRender && megaMenuCard ? (
              <HeaderElementSubLevel
                key={`subLevelItem${index}`}
                {...megaMenuCard}
                handleClickTracking={handleClickTracking}
                index={index}
                active={activeLevel2Index === index}
                language={locale}
                topLevelHover={topLevelHover}
                mouseEnterHandler={subLevelHoverHandler}
                mouseLeaveHandler={subLevelUnhoverHandler}
                subLevelHover={subLevelHover}
                sectionNotAvailableText={sectionNotAvailableText}
                pageNotAvailableText={pageNotAvailableText}
              />
            ) : (
              <span className="main-navigation--desktop__main__level2__item" key={`subLevelItem${index}`}></span>
            )}
          </div>
        )}
      </li>
    )
  } else {
    return null
  }
}

function HeaderElementSubLevel({
  active = false,
  mouseEnterHandler = null,
  mouseLeaveHandler = null,
  handleClickTracking,
  language,
  headline,
  linkArea,
  text,
  megaMenuElements,
  annotate,
  hasAnnotatedLinks,
  sectionNotAvailableText,
  pageNotAvailableText,
}) {
  const renderMegaMenuElements = (contentArea) => {
    return contentArea
      ? contentArea.map((block, i) => {
          switch (block.__type__) {
            case "MegaMenuLinkImageElementBlock":
            case "MegaMenuLinkElementBlock":
              return (
                <MegaMenuElement
                  key={i}
                  handleClickTracking={handleClickTracking}
                  image={block.image}
                  linkItem={block.linkItem}
                  text={block.text}
                  active={active}
                  annotateCard={annotate}
                />
              )
            case "MegaMenuLinkListElement":
              return (
                <MegaMenuLinkList
                  key={i}
                  handleClickTracking={handleClickTracking}
                  language={language}
                  firstLink={block.firstLink}
                  linkArea={block.linkArea}
                  active={active}
                  annotateCard={annotate}
                />
              )
          }
        })
      : null
  }

  return (
    <div
      className={`main-navigation--desktop__main__level2__item ${active ? "is-active" : ""}`}
      onMouseEnter={() => mouseEnterHandler()}
      onMouseLeave={() => mouseLeaveHandler()}
    >
      <div className={`w--wider`}>
        <div className={`text-section`}>
          <p className="headline">{`${headline}${annotate ? "*" : ""}`}</p>
          <span dangerouslySetInnerHTML={{ __html: text }}></span>
          {linkArea && linkArea.length > 0 ? (
            <div className={"links-container"}>
              {linkArea.map((link, index) => {
                const linkTarget = SelectionFactoryHelper.getFromSelectionFactory(link.linkTarget)
                return (
                  <a
                    tabIndex={active ? 0 : -1}
                    key={index}
                    href={link.linkUrl || undefined}
                    onClick={() => handleClickTracking(link.linkTracking)}
                    target={linkTarget}
                  >
                    <Svg iconName={"arrowright-slim"} />
                    {`${link.linkText}${!annotate && link.annotate ? "*" : ""}`}
                  </a>
                )
              })}
            </div>
          ) : (
            ""
          )}
        </div>
        <div className={`elements-section-wrapper`}>
          <div className={`elements-section`}>{renderMegaMenuElements(megaMenuElements)}</div>
          <div className={`annotation-text`}>
            {annotate ? sectionNotAvailableText.replace("{headline}", headline) : ""}
            {!annotate && hasAnnotatedLinks ? pageNotAvailableText : ""}
          </div>
        </div>
      </div>
      <div className={"bottom-shadow"}></div>
    </div>
  )
}

function MegaMenuElement({ handleClickTracking, image, linkItem, text, active, annotateCard }) {
  return (
    <a
      onClick={() => handleClickTracking(linkItem?.linkTracking)}
      tabIndex={active && linkItem?.linkUrl ? 0 : -1}
      href={linkItem?.linkUrl || undefined}
      className={`mega-menu-element ${image ? "has-image" : ""}`}
    >
      <div>
        {image ? <img src={image} /> : ""}
        <div className={"link-text"}>{`${linkItem?.linkText}${!annotateCard && linkItem?.annotate ? "*" : ""}`}</div>
        <span dangerouslySetInnerHTML={{ __html: text }}></span>
      </div>
    </a>
  )
}

function MegaMenuLinkList({ handleClickTracking, firstLink, linkArea, active, annotateCard }) {
  const firstLinkTarget = SelectionFactoryHelper.getFromSelectionFactory(firstLink.linkTarget)
  return (
    <div className={`mega-menu-link-list`}>
      <a
        tabIndex={active ? 0 : -1}
        className={`first-link`}
        href={firstLink.linkUrl || undefined}
        onClick={() => handleClickTracking(firstLink.linkTracking)}
        target={firstLinkTarget}
      >{`${firstLink?.linkText}${!annotateCard && firstLink?.annotate ? "*" : ""}`}</a>
      {linkArea && linkArea.length > 0
        ? linkArea.map((link, index) => {
            const linkTarget = SelectionFactoryHelper.getFromSelectionFactory(link.linkTarget)
            return (
              <a
                tabIndex={active ? 0 : -1}
                key={index}
                href={link.linkUrl || undefined}
                onClick={() => handleClickTracking(link.linkTracking)}
                target={linkTarget}
              >{`${link.linkText}${!annotateCard && link.annotate ? "*" : ""}`}</a>
            )
          })
        : ""}
    </div>
  )
}

function AccessibilityHeaderItems({ accessibleHeaderItems, setIsSearchActive, setTopLevelHover, setSubLevelHover, setActiveLevel2Index }) {
  let items = undefined
  let accessibleHeader = undefined

  const handleInteraction = () => {
    setIsSearchActive(false)
    setTopLevelHover(false)
    setSubLevelHover(false)
    setActiveLevel2Index(null)
  }

  if (accessibleHeaderItems)
    items = accessibleHeaderItems.map((item) => {
      return (
        <a
          key={item.linkText}
          onClick={() => handleInteraction()}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.keyCode === 13) {
              handleInteraction()
              return
            }
          }}
          className="accessibility-menu-item"
          href={item.link || item.remainingUrl}
          aria-label={item.ariaLabel || item.linkText}
        >
          {item.linkText}
        </a>
      )
    })

  if (items)
    accessibleHeader = items.length ? (
      <nav className="accessibility-nav-menu" aria-label="accessibility menu">
        {items}
      </nav>
    ) : null

  if (accessibleHeader)
    return (
      <nav className="accessibility-nav-menu" aria-label="accessibility menu">
        {items}
      </nav>
    )

  return null
}
